import React from 'react';
import PropTypes from 'prop-types';

import InputFieldErrorMessage from '../InputFieldErrorMessage';

import styles from './ControlledFormInput.module.scss';

const ControlledFormInput = ({
  field,
  onBlur,
  onChange,
  required = false,
  type = 'text',
  characterCounter = false,
  maxLength = 200,
  readOnly = false,
}) => {
  const Element = type === 'textarea' ? 'textarea' : 'input';
  return (
    <label className={styles.field} htmlFor={field.name}>
      <div className={styles.label}>
        <span id={`${field.name}-label`}>
          {field.label}
        </span>
        {required && <span className={styles.required}>*</span>}
      </div>
      {field.description && <div className={styles.description}>{field.description}</div>}
      <Element
        aria-labelledby={`${field.name}-label`}
        className={(field.touched && field.errors.length) ? `error ${styles.error__highlight}` : ''}
        type="text"
        id={field.name}
        name={field.name}
        placeholder={field.placeholder}
        value={field.value}
        maxLength={maxLength}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
      />
      {characterCounter && (
        <div className={styles['extra-info']}>
          <InputFieldErrorMessage field={field} fieldHasCounter />
          <div className={styles['character-counter']}>
            {field.value.length} / {maxLength}
          </div>
        </div>
      )}
      {!characterCounter && <InputFieldErrorMessage field={field} />}
    </label>
  );
};

ControlledFormInput.propTypes = {
  characterCounter: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
    touched: PropTypes.bool,
    value: PropTypes.string,
    placeholder: PropTypes.string,
  }).isRequired,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.string,
};

export default ControlledFormInput;
